<template>
  <v-form v-model="valid">
    <v-container class="pa-0" fluid>
      <v-row dense>
        <v-col cols="12">
          <v-select
            v-model="localFormData.PARKING_TYPE"
            :rules="[rules.required]"
            :items="items"
            :label="$t('FORMS.PARKING_SPACE_RENT.CHOOSE_TYPE') + ' *'"
            hide-details
            solo
            :append-icon="errors.parking_type ? 'mdi-alert-circle-outline' : 'mdi-chevron-down'"
            @update:error="errors = { ...errors, parking_type: $event }"
          ></v-select>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-checkbox
            v-if="localFormData.PARKING_TYPE == $t('FORMS.PARKING_SPACE_RENT.GARAGE_PARKING')"
            v-model="localFormData.CHARGING_POSSIBILITY"
            :label="$t('FORMS.PARKING_SPACE_RENT.CHARGING_POSSIBILITY')"
          />
          <v-checkbox
            v-if="localFormData.PARKING_TYPE"
            v-model="desiredStartDate"
            :label="$t('FORMS.PARKING_SPACE_RENT.DESIRED_RENT_DATE')"
          />
        </v-col>
      </v-row>

      <v-row v-if="desiredStartDate" dense>
        <v-col cols="12">
          <v-date-picker
            v-model="localFormData.DESIRED_RENT_DATE"
            full-width
            no-title
            class="mb-4"
          />
        </v-col>
      </v-row>

      <v-row dense text-center>
        <v-col cols="12">
          <slot name="button" :valid="valid" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <slot name="description" />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Rules from "@/app/modules/_global/classes/Rules";

export default {
  name: "ParkingSpaceRentForm",

  model: {
    prop: "formData"
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  data: vm => ({
    localFormData: null,

    desiredStartDate: false,
    items: [
      vm.$t("FORMS.PARKING_SPACE_RENT.GARAGE_PARKING"),
      vm.$t("FORMS.PARKING_SPACE_RENT.OUTDOOR_PARKING")
    ],

    valid: true,
    errors: {},

    rules: {
      required: Rules.required
    }
  }),

  watch: {
    localFormData: {
      deep: true,
      handler: "setFormData"
    }
  },

  created() {
    this.localFormData = Object.assign({}, this.formData);
  },

  methods: {
    setFormData() {
      this.$emit("input", this.localFormData);
    }
  }
};
</script>
